import a from 'i18n/en/general/a'
import b from 'i18n/en/general/b'
import c from 'i18n/en/general/c'
import d from 'i18n/en/general/d'
import e from 'i18n/en/general/e'
import f from 'i18n/en/general/f'
import h from 'i18n/en/general/h'
import i from 'i18n/en/general/i'
import m from 'i18n/en/general/m'
import n from 'i18n/en/general/n'
import o from 'i18n/en/general/o'
import p from 'i18n/en/general/p'
import r from 'i18n/en/general/r'
import s from 'i18n/en/general/s'
import t from 'i18n/en/general/t'
import u from 'i18n/en/general/u'

export default {
  ...a,
  ...b,
  ...c,
  ...d,
  ...e,
  ...f,
  ...h,
  ...i,
  ...m,
  ...n,
  ...o,
  ...p,
  ...r,
  ...s,
  ...t,
  ...u
}
